import React, { useState, useEffect } from "react";
import {
  Collapse,
  Form,
  Input,
  Select,
  Upload,
  Checkbox,
  message,
  notification,
} from "antd";
import Renderbtn from "../../../../pages/uih/wf_controllers/BtnController/renderButton";
import ServiceApi, { authUser } from "../../../../services/ServiceApi";
import axios from "axios";
import moment from "moment";
import { useDispatch } from "react-redux";
import { setJobProgressHistory } from "../../../../actions/jobDetailAction";
import { setJobProgressDetailPic } from "../../../../actions/jobProgressdetailPicAction";

import reqwest from "reqwest";
import { dynamicExternalFunction } from "../../../../pages/uih/wf_controllers/BtnController/dynamicAction";
import StatusInfoModal from "../../../utility/status_info_modal";
import {
  defaultFormItemLayout,
  tailLayout,
} from "../../../utility/form_layout";

const { Panel } = Collapse;
const { Option, OptGroup } = Select;
const JobProgressForm = (props) => {
  const auth = authUser();
  const {
    CompanyId,
    OperatorId,
    ProjectId,
    jobData,
    isReloadPage = true,
    isCollapsible = true,
    isShowArrow = true,
    onSuccess,
    isTitleDetail = false
  } = props;
  const [jobMaintenance] = jobData.result_maintenance ?? [null];
  const [jobAssetdetail] = jobData.result_assetdetail ?? [null];
  const [jobDetail] = jobData.result_job_detail ?? [null];
  const [formData, setFormData] = useState({
    activityType: [],
    progressDetailType: [],
    progressDetail: "",
    photoandVideo: "",
  });
  const [visibleModal, setVisibleModal] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [pStateFilter, setpStateFilter] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [externalUrl, setexternalUrl] = useState([]);
  const [loadingText, setloadingText] = useState("Loading");
  const [Spin, setSpin] = useState(true);
  const [statusInfoMode, setstatusInfoMode] = useState("success");
  const statusInfoModalCallBack = () => {
    setVisibleModal(false);
    if (isReloadPage) {
      window.location.reload();
    } else {
      onSuccess();
    }
  };
  const handleChange = (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      setFileList([...fileList, { ...info.file, action: "ADD" }]);
    }
  };

  const onFinish = (values) => {
    console.log("values", values);
    setDisableSubmit(true);
    setloadingText("Sending Progress Form");
    setVisibleModal(true);
    // return;
    ServiceApi.post("job_detail/insert_job_progress_detail", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_progress_detail_id: "0", // pi
      job_progress_id: jobAssetdetail?.job_progress_id,
      job_id: jobAssetdetail?.job_id,
      job_status_id: jobMaintenance?.job_status,
      job_progress_point: jobMaintenance?.job_progress_point,
      asset_id: jobAssetdetail?.asset_id,
      assign_by: auth.userId,
      assign_date: "2020-12-12",
      service_type_level_id: jobMaintenance?.service_type_level_id,
      progress_detail: values.progress_details || "", // ! data
      result_detail: "",
      progress_status: 0,
      acknowledge_date: "2020-12-12",
      acknowledge_status: "0",
      acknowledge_emp_id: "546",
      is_active: 1,
      activity_id: values.activity_type || "", // ! data
      progress_detail_type_id: values.progress_detail || "", // ! data
      create_date: moment().format(),
      update_date: moment().format(),
      delete_date: "2020-12-12",
      form_id: "",
      data_dynamic: "",
      create_by: auth.username,
      wfData: [
        {
          company_id: 3,
          current_flow: "M",
          from_main_process_id: jobMaintenance?.from_main_process_id,
          from_main_process_name: jobMaintenance?.from_main_process_name,
          from_sub_process_id: jobMaintenance?.from_sub_process_id,
          from_sub_process_name: jobMaintenance?.from_sub_process_name,
          next_flow: jobMaintenance?.next_flow,
          next_main_action_id: jobMaintenance?.next_main_action_id,
          next_main_action_name: jobMaintenance?.next_main_action_name,
          next_main_process_id: jobMaintenance?.next_main_process_id,
          next_main_process_name: jobMaintenance?.next_main_process_name,
          next_sub_action_id: jobMaintenance?.next_sub_action_id,
          next_sub_action_name: jobMaintenance?.next_sub_action_name,
          next_sub_dest_page_id: null,
          next_sub_dest_page_name: "",
          next_sub_process_id: null,
          next_sub_process_name: "",
          show_dest_page: null,
          style_sheet_format:
            "'backgroup_color:#000F9F;color:#FFFFFF;style:flat;'",
          to_user_id: jobMaintenance?.to_user_id,
          to_usergroup_id: jobMaintenance?.to_usergroup_id,
          to_usergroup_name: jobMaintenance?.to_usergroup_name,
          to_username: jobMaintenance?.userName,
          wf_id: jobMaintenance?.wf_id,
        },
      ],
    })
      .then((res) => {
        setDisableSubmit(false);
        const { data } = res;
        const { result } = data;
        if (result.code === "P" || result.value === "P") {
          message.success("Save data success");
          setloadingText("Upload Media");
          form.resetFields();
          const currentjobporgressid =
            data.data.oper_job_progress_detail[0].job_progress_detail_id;
          if (fileList.length > 0) {
            const images = new FormData();
            fileList
              .filter((s) => s.action === "ADD")
              .forEach((file) => {
                images.append("files", file?.originFileObj);
                images.append("job_id", jobAssetdetail?.job_id);
                images.append(
                  "job_progress_id",
                  jobAssetdetail?.job_progress_id
                );
                images.append("company_id", CompanyId);
                images.append("operator_id", OperatorId);
                images.append("project_id", ProjectId);
                images.append("job_category_id", jobDetail?.job_category_id);
                images.append("job_type_id", jobMaintenance?.jobtypeid);
                images.append("asset_id", jobAssetdetail?.asset_id);
                images.append("create_by", auth.username);
                images.append("pic_type", "P");
                images.append("job_reference_id", currentjobporgressid);
              });
            reqwest({
              url: `${process.env.REACT_APP_URL_API}job_detail/InsertImageListFile`,
              method: "post",
              processData: false,
              data: images,
              headers: {
                TokenUser: auth.token,
              },
              success: () => {
                // this.setState({
                //   fileList: [],
                //   uploading: false,
                //   modalstatus: true,
                // });
                fileList
                  .filter((s) => s.action === "ADD")
                  .forEach((file) => {
                    images.delete("files", file?.originFileObj);
                    images.delete("job_id", jobAssetdetail?.job_id);
                    images.delete(
                      "job_progress_id",
                      jobAssetdetail?.job_progress_id
                    );
                    images.delete("company_id", CompanyId);
                    images.delete("operator_id", OperatorId);
                    images.delete("project_id", ProjectId);
                    images.delete(
                      "job_category_id",
                      jobDetail?.job_category_id
                    );
                    images.delete("job_type_id", jobMaintenance?.jobtypeid);
                    images.delete("asset_id", jobAssetdetail?.asset_id);
                    images.delete("create_by", auth.username);
                    images.delete("pic_type", "P");
                    images.delete("job_reference_id", currentjobporgressid);
                  });

                setFileList(
                  fileList.map((item) => ({ ...item, action: "UPDATE" }))
                );
                message.success("upload successfully.");
              },
              error: () => {
                // this.setState({
                //   uploading: false,
                // });
                message.error("upload failed.");
              },
            });
          }
          // callExternal();
          setloadingText("Call External URL");
          callExternal(currentjobporgressid);
          setTimeout(() => {
            ServiceApi.post("job_detail/SendWorklogToSCCD", {
              job_id: jobAssetdetail?.job_id,
              company_id: CompanyId,
              operator_id: OperatorId,
              project_id: ProjectId,
            }).then((res) => {
              const { data } = res;
              const { result } = data;
              if (result.code === "P" || result.value === "P") {
                ServiceApi.post("job_detail/job_progress_detail_list", {
                  company_id: CompanyId,
                  operator_id: OperatorId,
                  project_id: ProjectId,
                  job_progress_detail_id: "0",
                  job_progress_id: jobAssetdetail?.job_progress_id,
                  job_id: jobAssetdetail?.job_id,
                })
                  .then((res) => {
                    const progressList = res.data.data?.job_progress_detail;
                    const oper_pic = res.data.data?.result_oper_pic;
                    // .filter(b => b.job_id === jobAssetdetail?.job_id)
                    const records = progressList
                      // ?.filter((b) => b.problem_detail)
                      .filter((b) => b.job_id === jobAssetdetail?.job_id)
                      .map((s) => ({
                        ...s,
                        title: s.progress_type_Detail || "N/A",
                        flag: s.progress_status_flag || "N/A",
                        date: moment(s.update_date).format("DD/MM/YYYY"),
                        time: moment(s.update_date).format("HH:mm"),
                        detail: s.progress_detail || "N/A",
                        updateby: s.create_by_name || "System",
                      }));

                    // setProgressRecord(records);
                    // setFormData()

                    dispatch(setJobProgressHistory(records));

                    dispatch(setJobProgressDetailPic(oper_pic));
                  })
                  .catch((err) => console.log(err));
              } else {
                notification.error({
                  message: "Error",
                  description: result?.showText,
                  duration: 5,
                  className: "font-thai-b fs-18",
                });
                setDisableSubmit(false);
              }
            });
          }, 2000);
        } else if (result.code === "F") {
          notification.error({
            message: "Error",
            description: result?.showText,
            duration: 5,
            className: "font-thai-b fs-18",
          });
          setDisableSubmit(false);
        }
      })
      .catch((err) => {
        setDisableSubmit(false);
        notification.error({
          message: "Error",
          description: err,
          duration: 5,
          className: "font-thai-b fs-18",
        });
      });
  };

  useEffect(() => {
    axios
      .all([
        ServiceApi.post("master_data/activity_single", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          // MainProcessID: pStateFilter ? jobDetail?.mainProcessID : null,
          // SubProcessID: pStateFilter ? jobDetail?.subProcessID : null,
        }),
        ServiceApi.post("master_data/job_progress_type", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          job_type_id: jobDetail?.job_type_id,
          MainProcessID: pStateFilter ? jobDetail?.mainProcessID : null,
          SubProcessID: pStateFilter ? jobDetail?.subProcessID : null,
        }),
      ])
      .then(([resActivity, resProgressType]) => {
        const { data: resultActivity } = resActivity;
        const { data: resultProgressType } = resProgressType;
        const activityList = resultActivity?.data.result.map((s) => ({
          ...s,
          value: s.activity_id,
          label: s.activity_name,
        }));
        const progressTypeList = resultProgressType?.data.result.map((s) => ({
          ...s,
          value: s.progress_type_id,
          label: s.progress_type_name,
        }));
        setFormData({
          ...formData,
          activityType: activityList,
          progressDetailType: progressTypeList,
        });

        // console.log("res2", resultProgressType);
        // console.log("authUser", auth);
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pStateFilter]);

  const onCheckFilterP = (e) => {
    const checked = e.target.checked;
    setpStateFilter(checked);
  };
  function genOption() {
    if (formData.progressDetailType.length > 0) {
      const Optionheaderraw = formData.progressDetailType.filter(
        (data) => JSON.parse(data.data_dynamic).option_type === "group"
      );
      const Optioraw = formData.progressDetailType.filter(
        (data) => JSON.parse(data.data_dynamic).option_type === "label"
      );
      Optionheaderraw.sort(function (a, b) {
        return (
          JSON.parse(a.data_dynamic).option_seq -
          JSON.parse(b.data_dynamic).option_seq
        );
      });
      Optioraw.sort(function (a, b) {
        return (
          JSON.parse(a.data_dynamic).option_seq -
          JSON.parse(b.data_dynamic).option_seq
        );
      });
      return (
        <>
          {Optionheaderraw && Optionheaderraw.length > 0
            ? Optionheaderraw?.map((data, index) => (
                <OptGroup
                  label={data.label}
                  key={`Option_progress_index_${index}`}
                >
                  {Optioraw && Optioraw.length > 0
                    ? Optioraw?.map((datas, indexs) => {
                        if (
                          JSON.parse(data.data_dynamic).option_group_id ===
                          JSON.parse(datas.data_dynamic).option_group_id
                        ) {
                          return (
                            <Option
                              key={`progress_detail_form_progress_${
                                indexs + 1
                              }`}
                              value={datas.value}
                              data_dynamic={datas.data_dynamic}
                            >
                              <span className="default-thai-font">
                                {datas.label}
                              </span>
                            </Option>
                          );
                        }
                      })
                    : null}
                </OptGroup>
              ))
            : Optioraw && Optioraw.length > 0
            ? Optioraw?.map((datass, indexss) => (
                <option
                  key={`progress_detail_form_progress_${indexss + 1}`}
                  value={datass.value}
                  data_dynamic={datass.data_dynamic}
                >
                  <span className="default-thai-font">{datass.label}</span>
                </option>
              ))
            : null}
        </>
      );
    }
  }

  function checkSelecthasecternalUrl(value, att) {
    if (
      att.data_dynamic &&
      att.data_dynamic !== undefined &&
      att.data_dynamic !== "" &&
      att.data_dynamic !== "{}"
    ) {
      const rawDatadynamic = JSON.parse(att.data_dynamic);
      if (
        rawDatadynamic.external_url &&
        rawDatadynamic.external_url.length > 0
      ) {
        setexternalUrl(rawDatadynamic.external_url);
      } else {
        setexternalUrl([]);
      }
    }
  }
  function callExternal(i_job_progress_detail_id) {
    if (externalUrl !== undefined && externalUrl.length > 0) {
      externalUrl.map((data) => {
        if (data.external_type === "json") {
          dynamicExternalFunction[data.function_name](
            data.api_url,
            jobAssetdetail?.job_id,
            i_job_progress_detail_id
          )
            .then((res) => {
              if (res.data.Result?.Code === "P") {
                setloadingText("Save Data and Call External URL Success");
                setSpin(false);
                // notification.info({
                //   message: "แจ้งเตือน",
                //   description: `ส่งข้อมูลการ job progress ไปที่ระบบ Interface เรียบร้อยแล้ว ${res.data.Result.Description}`,
                //   duration: 5,
                //   className: "font-thai-b fs-18",
                // });
              } else if (res.data.Result?.Code === "F") {
                // notification.warning({
                //   message: "แจ้งเตือน",
                //   description: `ระบบได้ทำการบันทึก job progress แล้ว แต่ไม่สามารถส่งข้อมูลไปที่ Interface ได้ โปรดตรวจสอบอีกครั้ง || ${res.data.Result.Description}`,
                //   duration: 5,
                //   className: "font-thai-b fs-18",
                // });
                setloadingText(
                  "Save Data Success || Error External : " +
                    res.data.Result.Description
                );
                setstatusInfoMode("error");
                setSpin(false);
              }
            })
            .catch((err) => {
              setloadingText("Save Data Success || Error External : " + err);
              setstatusInfoMode("error");
              setSpin(false);
              // notification.warning({
              //   message: "แจ้งเตือน",
              //   description: `ระบบได้ทำการบันทึก job progress แล้ว แต่ไม่สามารถส่งข้อมูลไปที่ Interface ได้ โปรดตรวจสอบอีกครั้ง || ${err}`,
              //   duration: 5,
              //   className: "font-thai-b fs-18",
              // });
            });
        } else {
          setloadingText("Save Data Success");
          setSpin(false);
        }
      });
    } else {
      setloadingText("Save Data Success");
      setSpin(false);
    }
  }
  return (
    <>
      <Collapse
        collapsible={isCollapsible ? "" : "disabled"}
        expandIconPosition="right"
        defaultActiveKey={["1"]}
      >
        <Panel
          showArrow={isShowArrow}
          header={
            <>
              <h4>{`Job Progress Form${isTitleDetail ? ` (S/O ID : ${jobDetail.so_id})` : ""}`}</h4>
            </>
          }
          key="1"
        >
          <div className="d-flex align-content-md-start flex-wrap w-100">
            <div className="col col-12">
              <Form
                name="job_progress_form"
                onFinish={onFinish}
                form={form}
                {...defaultFormItemLayout}
              >
                <Form.Item
                  name="activity_type"
                  label="Activity Type :"
                  rules={[
                    { required: true, message: "Activity Type is required" },
                  ]}
                >
                  <Select placeholder="Select">
                    {formData.activityType.map((data, index) => (
                      <Option
                        key={`activity_type_form_progress_${index + 1}`}
                        value={data.value}
                      >
                        <span className="default-thai-font">{data.label}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="progress_detail"
                  label="Progress Detail : "
                  rules={[
                    { required: true, message: "Progress Detail is required" },
                  ]}
                >
                  <Select
                    placeholder="Select"
                    onChange={checkSelecthasecternalUrl.bind(this)}
                  >
                    {formData.progressDetailType.length > 0
                      ? genOption()
                      : null}
                  </Select>
                </Form.Item>
                <div className="row">
                  <div style={{ marginLeft: "26%" }}>
                    <Checkbox onChange={onCheckFilterP}>
                      Filter by P-Stage
                    </Checkbox>
                  </div>
                </div>
                <Form.Item name="progress_details" label="Progress Details : ">
                  <Input.TextArea rows="5"></Input.TextArea>
                </Form.Item>
                <Form.Item label="Photo and Video" name="photoandvideo">
                  <Form.Item
                    style={{ border: "1px solid #d9d9d9", padding: 10 }}
                  >
                    <Upload
                      name="image"
                      // showUploadList={false}
                      listType="picture-card"
                      className="avatar-uploader"
                      action={`${process.env.REACT_APP_URL_API}mockupupload/`}
                      // beforeUpload={beforeUpload}
                      onChange={handleChange}
                      onRemove={(file) => {
                        setFileList(fileList.filter((e) => e.uid !== file.uid));
                      }}
                    >
                      {fileList.length >= 8 ? null : (
                        <div style={{ marginTop: 8 }}>Upload</div>
                      )}
                    </Upload>
                  </Form.Item>
                </Form.Item>
                {/* <Form.Item {...tailLayout}> */}
                <div className="text-center">
                  <Renderbtn
                    renderBtn={{
                      visible: true,
                      html_tag: "button",
                      type: "Text",
                      text: `Clear`,
                      css: "btn btn-xs btn-light",
                    }}
                    btnMiddleware={() => {
                      form.resetFields();
                      setDisableSubmit(false);
                    }}
                    index="view_btn_closemodal"
                    item={null}
                    disable={false}
                  ></Renderbtn>
                  {/* <Button
                    htmlType="button"
                    className="mr-3"
                    onClick={() => {
                      form.resetFields();
                      setDisableSubmit(false);
                    }}
                  >
                    Clear
                  </Button> */}
                  {/* <Button
                    type="primary"
                    disabled={disableSubmit}
                    htmlType="submit"
                  >
                    Save
                  </Button> */}
                  <Renderbtn
                    renderBtn={{
                      visible: true,
                      html_tag: "button",
                      type: "Text",
                      text: `Save`,
                      css: "btn btn-xs btn-submit",
                    }}
                    btnMiddleware={() => form.submit()}
                    index="view_submit_form"
                    item={null}
                    disable={false}
                  ></Renderbtn>
                </div>
                {/* </Form.Item> */}
              </Form>
            </div>
          </div>

          <StatusInfoModal
            visible={visibleModal}
            showSpinIcon={Spin}
            statusText={loadingText}
            mode={statusInfoMode}
            callbackFunction={statusInfoModalCallBack}
          ></StatusInfoModal>
        </Panel>
      </Collapse>
    </>
  );
};

export default JobProgressForm;
